import * as React from 'react';
import {
    UpgradeHelper, IJourneyItem, AdminToolPanelHelper, IAdminToolPanel
} from '../../../helpers';
import { Button, ButtonType } from 'office-ui-fabric-react';
import { PAGING_ITEM_AMOUNT } from '../../../constants';
declare var jQuery;
interface IProps {
    pagingMax: any;
    list: any;
    pagingNumber: any;
    panelName: string;
    adminToolState: any
    disable: boolean;

}

export class ListPaging extends React.Component<IProps, any> {
    componentDidMount() {
    }

    nextButtonClick() {
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let pagingNumber: number = AdminToolPanelHelper.GetPaging(panel);
        AdminToolPanelHelper.SetPaging(this.props.adminToolState, this.props.panelName, pagingNumber + PAGING_ITEM_AMOUNT)

    }
    backButtonClick() {
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let pagingNumber: number = AdminToolPanelHelper.GetPaging(panel);
        AdminToolPanelHelper.SetPaging(this.props.adminToolState, this.props.panelName, pagingNumber - PAGING_ITEM_AMOUNT)
    }
    render() {

        let listLength: number = (this.props.list) ? this.props.list.length : 0;

        let showingTo: number = this.props.pagingMax < listLength ?
            this.props.pagingMax : this.props.pagingMax -
            (this.props.pagingMax - listLength);

        let showingFrom: number = this.props.pagingNumber > 0 ? this.props.pagingNumber + 1 : 0;

        return (<div>
            <span>Showing {showingFrom} to {showingTo} of {listLength} {this.props.adminToolState.tab === 'JE Settings' ? 'JE Settings' : 'Journeys'}</span>
            <br />
            <Button buttonType={ButtonType.primary}
                disabled={(showingFrom > 0 && !this.props.disable) ? false : true}
                onClick={() => {
                    this.backButtonClick();
                }}>Back</Button>&nbsp;
            <Button buttonType={ButtonType.primary}
                disabled={(listLength >= this.props.pagingNumber + 11 && !this.props.disable) ? false : true}
                onClick={() => {
                    this.nextButtonClick();
                }}>Next</Button>
        </div>);
    }
}  



// WEBPACK FOOTER //
// ./source/ts/components/admintool/panels/listpaging.tsx